import React from 'react';

function Index() {
  return (
    <div className="index">

    </div>
  );
}

export default Index;
